/**
 * Body video block.
 * @module components/manage/Blocks/Video/Body
 *
 * Customizations (from VideoViewer):
 * - support external sources for preview image
 * - added ConditionalEmbed
 * - overhauled url checking, it would break on correct links and allow incorrect ones
 */

import React from 'react';
import PropTypes from 'prop-types';

import { VideoViewer } from '@package/components';

/**
 * Body video block class.
 * @class Body
 * @extends Component
 */
const Body = ({ data, isEditMode }) => {
  return <VideoViewer {...data} isEditMode={isEditMode} />;
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
